module.exports = __webpack_public_path__ + "img/address_map.ddace48f.png";